export default "__VITE_ASSET__DS7MD3pV__"